import axios from 'axios';

const urlAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://backend.codigolimpio.es',
});

export default urlAxios;